module.exports = __webpack_public_path__ + "static/img/22.58527ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/22.png
// module id = mD6c
// module chunks = 0